module.exports = __webpack_public_path__ + "static/img/company-img-1.b2f937f8.png";